import { FormlyFieldConfig } from '@ngx-formly/core';

import {
  ISnCheckboxTemplateOptions,
  ISnCheckboxGroupTemplateOptions,
} from './checkbox-template-options.interface';

export interface ISnCheckboxFormFieldConfig extends FormlyFieldConfig {
  type: 'checkbox';
  templateOptions: ISnCheckboxTemplateOptions | ISnCheckboxGroupTemplateOptions;
}
